import React, { Component } from "react";
import { Modal } from "antd";
import Bridge from "../../../constants/Bridge";

export default class UserListModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userList: [],
      title: "",
      viewDescModalStatus: false,
    };
  }
  componentDidMount() {
    console.log("props", this.props.data);
  }
  get_voted_user_list = (item) => {
    let param = "?fr_id=" + item.fr_id;
    Bridge.feature_roadmap
      .vote_user_list(param)
      .then((result) => {
        if (result.status == "1") {
          this.setState({
            userList: result.data,
            viewDescModalStatus: true,
          });
          console.log("user list", result);
          // this.props.refresh();
        }
      })
      .catch((error) => {});
  };
  closeViewDescModal = () => {
    this.setState({
      userList: [],
      title: "",
      viewDescModalStatus: false,
    });
  };
  render() {
    return (
      <div>
        <a
          href="#!"
          style={{
            color: "#1cc31d",
            fontWeight: "500",
          }}
          onClick={() => this.get_voted_user_list(this.props.data)}
        >
          +{this.props.data.total_votes}
        </a>
        <Modal
          title={<h5>{this.props.data.title}</h5>}
          visible={this.state.viewDescModalStatus}
          onOk={() => this.closeViewDescModal()}
          onCancel={() => this.closeViewDescModal()}
          okText="Ok"
          cancelText="Cancel"
          width={600}
        >
          <div style={{ fontSize: 17, padding: "25px 0 15px 10px" }}>
            {this.state.userList.length > 0 &&
              this.state.userList.map((item, index) => {
                return (
                  <div>
                    <p>
                      <span style={{ fontWeight: "500" }}>User Name:</span>{" "}
                      <span style={{ textTransform: "capitalize" }}>
                        {item.name}
                      </span>
                    </p>
                    <p>
                      <span style={{ fontWeight: "500" }}>Member Of:</span>{" "}
                      <span>{item.member_name}</span>
                    </p>
                    <hr />
                  </div>
                );
              })}
          </div>
        </Modal>
      </div>
    );
  }
}
